/**
 * @botto/module-sms — SMS Routing module.
 *
 * Owns: routes /sms/*, side-menu section "SMS", openapi-fetch client.
 * Publishes cross-module lookups (aggregators, templates, senders, streams,
 * messageTypes, domains) via @botto/core/stores so Tariffs/CDP/Tracker can consume them.
 */
import type { ModuleManifest } from '@botto/core';
import { registerLookups } from '@botto/core';
import { routes } from './routes';
import { menu } from './menu';
import {
  fetchAggregators,
  fetchTemplates,
  fetchSenderNames,
  fetchStreams,
  fetchMessageTypes,
  fetchDomains,
} from './api/lookups';

const manifest: ModuleManifest = {
  id: 'sms',
  title: 'SMS',
  routes,
  menu,
  init() {
    registerLookups({
      aggregators: fetchAggregators,
      templates: fetchTemplates,
      senderNames: fetchSenderNames,
      streams: fetchStreams,
      messageTypes: fetchMessageTypes,
      domains: fetchDomains,
    });
  },
};

export default manifest;
export * from './api/lookups';
